export default "__VITE_ASSET__nqR4KkX0__"